import { CustomFormTemplate } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  template: CustomFormTemplate;
}

interface ResponseDataType {
  template_import_json: string;
}

export const exportCustomFormTemplateRequest = ({ token, template }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template/export-json`, {
    method: 'POST',
    token,
    body: template,
  });
};